import { useEffect, useState } from 'react';
import { loadDeviceConfigSnapshot } from './siteControlApi';

export default function useDeviceConfigSnapshot(siteId) {
  const [snapshot, setSnapshot] = useState(null);
  useEffect(() => {
    let active = true;
    let poll;
    setSnapshot(null);
    if (!siteId) return undefined;
    const refresh = async () => {
      let delay = 15000;
      try {
        const result = await loadDeviceConfigSnapshot(siteId);
        if (active) setSnapshot(result);
        if (result?.targets?.some((target) => ['queued', 'running'].includes(target.restartJob?.status))) delay = 2000;
      } catch (_) {
        if (active) setSnapshot(null);
      } finally {
        if (active) poll = setTimeout(refresh, delay);
      }
    };
    refresh();
    return () => {
      active = false;
      clearTimeout(poll);
    };
  }, [siteId]);
  useEffect(() => {
    if (!Number.isFinite(snapshot?.expiresAtEpochMs)) return undefined;
    const expiry = setTimeout(() => setSnapshot((current) => current === snapshot ? null : current),
      Math.max(0, snapshot.expiresAtEpochMs - Date.now()));
    return () => clearTimeout(expiry);
  }, [snapshot]);
  if (Number(snapshot?.siteId) !== Number(siteId) || !snapshot
      || !Number.isFinite(snapshot.expiresAtEpochMs)
      || snapshot.expiresAtEpochMs <= Date.now()) return null;
  return snapshot;
}
